/* unplugin-vue-components disabled */import { render } from "./CollectUserConnect.vue?vue&type=template&id=5fca306e&scoped=true"
import script from "./CollectUserConnect.vue?vue&type=script&lang=js"
export * from "./CollectUserConnect.vue?vue&type=script&lang=js"

import "./CollectUserConnect.vue?vue&type=style&index=0&id=5fca306e&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fca306e"]])

export default __exports__